import CustomZObject from './CustomZObject.js';

export default class Varz extends CustomZObject {
    constructor(zobject) {
        super(zobject);
    }
}

